import { gql } from '@apollo/client/core'
import { CORE_SUBSCRIPTION_FIELDS } from '@src/graphql/fragments/subscription'

const UPDATE_SUBSCRIPTION_PRODUCT = gql`
  ${CORE_SUBSCRIPTION_FIELDS}
  mutation updateSubscriptionProduct($id: ID!, $nextProduct: BillingProduct!) {
    updateSubscriptionProduct(id: $id, nextProduct: $nextProduct) {
      ...CoreSubscriptionFields
    }
  }
`

export default UPDATE_SUBSCRIPTION_PRODUCT
